/**
 * Mixin for computed properties and methods used in app navigation
 */
import {mapGetters} from "vuex";

export default {
	computed: {
		...mapGetters(['user', 'logSearchParams', 'neutral']),
		avatar() {
			return this.user ? this.user.firstName.substr(0, 1) + this.user.lastName.substr(0, 1) : '';
		},
		isVeneerSearch() {
			return this.$route.name === 'search' || this.$route.path === '/' ? 'q-tab--active' : '';
		}
	}
}